import { Const } from '../lib/const.cls'

export const mutations = {

    [Const.SET_REGISTER_DATA]: (state, data) => {
        state.registerData = data
    },
    [Const.SET_PAYU_REQUEST_INITIATE]: (state, data) => {
        state.paymentData = data
    },
    [Const.SET_TIME_SLOTS]: (state, data) => {
        state.timeSlots = data
    },
}



// WEBPACK FOOTER //
// ./src/plugins/giniView/provider/candle-history/store-addons/mutations.js